<template>
  <div tabindex="0" aria-haspopup="true" aria-label="Select country" class="page-header-country" :style="{ width: (size || 16) + 'px' }">
    <img :src="country === 'CA' ? caFlag : usFlag" alt="Select Country" :style="{ width: (size || 16) + 'px', height: (size || 16) + 'px' }" />
    <div class="page-header-country-select-wrapper">
      <div class="page-header-country-select">
        <a class="page-header-country-select-us" tabindex="0" aria-label="Change to US" @click.prevent="$emit('change', 'US')"
          ><img :data-src="usFlag" class="lazyload" /><span class="country-select-label">United States</span></a
        >
        <a class="page-header-country-select-ca" tabindex="0" aria-label="Change to Canada" @click.prevent="$emit('change', 'CA')"
          ><img :data-src="caFlag" class="lazyload" /><span class="country-select-label">Canada</span></a
        >
      </div>
    </div>
  </div>
</template>
<script>
import caFlag from '@/assets/flags/ai-Can.png';
import usFlag from '@/assets/flags/ai-US.png';

export default {
  props: {
    country: {
      type: String,
    },
    size: {
      type: Number,
    },
    caFlag: {
      default: caFlag,
    },
    usFlag: {
      default: usFlag,
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.page-header-country {
  width: 16px;
  position: relative;
  padding: 0px 5px 0px 5px;
  cursor: pointer;
  z-index: 2;

  img {
    margin-top: -2px;
  }

  /* purgecss ignore */
  &:hover,
  &:focus,
  &:active {
    .page-header-country-select-wrapper {
      visibility: visible;
      border-top: 10px solid transparent;
    }
  }

  .page-header-country-select-wrapper {
    left: -10px;
    position: absolute;
    visibility: hidden;
  }

  .page-header-country-select {
    border-radius: 4px;
    box-shadow: 0 var(--box-shadow-blur) var(--box-shadow-spread) var(--shadow-color);
    padding: var(--space-2) var(--space-4) var(--space-2) var(--space-4);
    background: var(--white);
  }

  .page-header-country-select {
    .page-header-country-select-us,
    .page-header-country-select-ca {
      white-space: nowrap;
      display: flex;
      align-items: center;
      background-color: transparent;

      /* purgecss ignore */
      &:not(:last-child) {
        margin-bottom: var(--space-1);
      }

      img {
        margin: 5px 10px 5px 0px;
        display: inline-block;
        min-width: 16px;
        max-width: 16px;
      }
    }
  }

  .page-header-country-select-icon {
    display: flex;
    align-items: center;
    width: 16px;
  }

  .country-select-label {
    font-size: var(--font-size-12);
    line-height: var(--line-height-12);
  }
}
</style>
